import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Link } from "@app/components/common";

export const LegalAndTerms: FC = () => {
  const { t } = useTranslation("footer");

  const pageLinks = [
    {
      to: "/legal",
      label: t("legal"),
    },
    {
      to: "/legal/terms-of-use",
      label: t("terms_of_use"),
    },
    {
      to: "/legal/privacy-policy",
      label: t("privacy_policy"),
    },
    {
      to: "/contact/ombudsman",
      label: t("ombudsman"),
    },
  ];

  return (
    <>
      {pageLinks.map((link) => (
        <div key={link.label}>
          <Link
            to={link.to}
            className={classNames(
              "text-no-underline text-small text-primary-content duration-300",
              "hover:text-grey-neutral",
            )}
          >
            {link.label}
          </Link>
        </div>
      ))}
    </>
  );
};
